/* eslint-disable no-use-before-define */
import React from 'react'
import { showModal } from '../twd'

export default ({showBook, allowTrading, holdCusip:cusip}) => {

    if (!showBook) return ''

    return <span
        data-name="offerings-book-icon"
        data-cusip={cusip}
        style={{cursor:'pointer'}}
        onClick={(e) => {
            showModal({
                view: 'depth-of-market',
                cusip,
                allowTrading,
                from: 'offerings',
                source: e.target,
            })
        }}
    >{BOOK_ICON}</span>
}

const BOOK_ICON = (
    <svg viewBox="0 0 18 14" width="18" height="18" aria-label="Book">
    <path d="M 15 0.375 C 14.167 0.112 13.252 0 12.375 0 C 10.912 0 9.337 0.3 8.25 1.125 C 7.162 0.3 5.587 0 4.125 0 C 2.662 0 1.087 0.3 0 1.125 L 0 12.112 C 0 12.3 0.188 12.487 0.375 12.487 C 0.45 12.487 0.487 12.45 0.562 12.45 C 1.575 11.962 3.037 11.625 4.125 11.625 C 5.587 11.625 7.162 11.925 8.25 12.75 C 9.262 12.112 11.1 11.625 12.375 11.625 C 13.612 11.625 14.887 11.85 15.937 12.412 C 16.012 12.45 16.05 12.45 16.125 12.45 C 16.312 12.45 16.5 12.262 16.5 12.075 L 16.5 1.125 C 16.05 0.787 15.562 0.562 15 0.375 Z M 15 10.5 C 14.175 10.237 13.275 10.125 12.375 10.125 C 11.1 10.125 9.262 10.612 8.25 11.25 L 8.25 2.625 C 9.262 1.987 11.1 1.5 12.375 1.5 C 13.275 1.5 14.175 1.612 15 1.875 L 15 10.5 Z" fill="var(--primary-base-color)" data-bx-origin="0 0"></path>
    <path d="M 12.089 4.058 C 12.749 4.058 13.387 4.125 13.964 4.253 L 13.964 3.113 C 13.372 3 12.734 2.933 12.089 2.933 C 10.814 2.933 9.659 3.15 8.714 3.555 L 8.714 4.8 C 9.562 4.32 10.739 4.058 12.089 4.058 Z" fill="var(--primary-base-color)" data-bx-origin="-1.659809 -1.570969"></path>
    <path d="M 12.15 6.407 C 12.81 6.407 13.448 6.474 14.025 6.602 L 14.025 5.462 C 13.433 5.349 12.795 5.282 12.15 5.282 C 10.875 5.282 9.72 5.499 8.775 5.904 L 8.775 7.149 C 9.623 6.669 10.8 6.407 12.15 6.407 Z" fill="var(--primary-base-color)" data-bx-origin="-1.671428 -2.829138"></path>
    <path d="M 12.263 8.594 C 12.923 8.594 13.561 8.661 14.138 8.789 L 14.138 7.649 C 13.546 7.536 12.908 7.469 12.263 7.469 C 10.988 7.469 9.833 7.686 8.888 8.091 L 8.888 9.336 C 9.736 8.856 10.913 8.594 12.263 8.594 Z" fill="var(--primary-base-color)" data-bx-origin="-1.692953 -4.000534"></path>
    </svg>
)




// WEBPACK FOOTER //
// ./src/offerings/format-book.js